import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import {FeaturesProvider} from './context/FeaturesContext';
import TrailingSlashRedirect from './router/TrailingSlashRedirect';

import PrivateRoute from './router/PrivateRoute';
import Consultant from './pages/admin/consultant/consultant';
import Administration from './pages/consultant/administration/administration';
import OverflowSimulator from './pages/consultant/overflow/OverflowSimulator';
import ErrorPage from './error404';
import NavBar from './components/organisms/navigation/header/Navbar';
import RootRedirect from './router/rootRedirect';
import Logout from './pages/logout/logout';
import {ConsultantProvider} from './context/ConsultantContext';
import ComponentTest from './components/ui/ComponentTest';
import ConsultantIndex from './components/macro-organisms/tabs/consultants-vision-admin/ConsultantIndex';
import StatementTab from './components/macro-organisms/tabs/consultants-vision-admin/statement/StatementTab';
import InformationTab from './components/macro-organisms/tabs/consultants-vision-admin/information/InformationTab';
import DetailsAboutConsultant from './components/macro-organisms/tabs/consultants-vision-admin/DetailsAboutConsultant';
import StatementTabUser from './components/macro-organisms/tabs/consultant-vision-user/statement/StatementTabUser';
import InformationTabUser from './components/macro-organisms/tabs/consultant-vision-user/information/InformationTabUser';
import CVTab from './components/macro-organisms/tabs/consultants-vision-admin/cv/cvTab';
import GenerateCV from './components/macro-organisms/tabs/consultants-vision-admin/cv/GenerateCV';
import ExpenseTabUser from './components/macro-organisms/tabs/consultant-vision-user/expense-account/ExpenseTabUser.jsx';
import ExpenseTab from './components/macro-organisms/tabs/consultants-vision-admin/expense-account/ExpenseTab';
import useMobileDetect from './utils/useMobileDetect';
import ErrorMobile from './errorMobile';
import Unauthorized from './pages/unauthorized/Unauthorized';
import CompanyBenefitsTabUser from './components/macro-organisms/tabs/consultant-vision-user/companyBenefit/CompanyBenefitsTabUser';
import PayslipTabUser from './components/macro-organisms/tabs/consultant-vision-user/payslip/payslipTabUser';
import CompanyBenefitsTab from './components/macro-organisms/tabs/consultants-vision-admin/companyBenefit/CompanyBenefitsTab';
import PayslipTab from './components/macro-organisms/tabs/consultants-vision-admin/payslib/PayslipTab';
import TimesheetTab from './components/macro-organisms/tabs/consultants-vision-admin/timesheet/TimesheetTab';
import TimesheetTabUser from './components/macro-organisms/tabs/consultant-vision-user/timesheet/TimesheetTabUser';
import Prospects from './pages/admin/prospects/Prospects';
import ProspectsHome from './pages/admin/prospects/ProspectsHome';
import CVProspect from './pages/admin/prospects/CVProspect';
import Management from './pages/admin/management/Management';
import ManagementWebsite from './pages/admin/management/ManagementWebsite';
import ManagementOnboarding from './pages/admin/management/ManagementOnboarding';
import ManagementOnboardingCandidateDetails from './pages/admin/management/ManagementOnboardingCandidateDetails';
import {Toaster} from './components/organisms/feedback/toaster';
import {NotificationProvider} from './hooks/global-hooks/NotificationContext';
import OverflowHome from './components/overflow/OverflowHome';
import OverflowAccountTab from './pages/consultant/overflow/OverflowAccountTab';
import {AppDataProvider} from './hooks/global-hooks/AppDataContext';


const App = () => {
    const isMobile = useMobileDetect();

    if (isMobile) {
        // Affiche une page d'erreur ou un composant spécifique pour les mobiles
        return (
            <Router>
                <TrailingSlashRedirect>
                    <AuthProvider>
                        <NotificationProvider>
                            <NavBar/>
                            <Routes>
                                <Route path="/unauthorized" element={<Unauthorized/>}/>
                                <Route path="*" element={<ErrorMobile/>}/>
                            </Routes>
                        </NotificationProvider>
                    </AuthProvider>
                </TrailingSlashRedirect>
            </Router>
        );
    }

    return (
        <Router>
            <TrailingSlashRedirect>
                <FeaturesProvider>
                    <AuthProvider>
                        <NotificationProvider>
                            <AppDataProvider>
                                <Toaster/>
                                <NavBar/>
                                <Routes>
                                {/* Phase de développement uniquement */}
                                {/* <Route path="/test" element={<ComponentTest/>}/> */}

                                <Route path="/logout" element={<Logout/>}/>
                                <Route path="/unauthorized" element={<Unauthorized/>}/>

                                {/* Gère la redirection à la racine */}
                                <Route path="/" element={<RootRedirect />} />{" "}

                                {/* Onboarding */}

                                {/* Privates routes */}
                                {/* For admin vision */}
                                <Route path="/consultant" element={<PrivateRoute element={<ConsultantProvider><Consultant /></ConsultantProvider>} />}>
                                    <Route index element={<ConsultantIndex />} />
                                    <Route path=":id" element={<PrivateRoute element={<DetailsAboutConsultant />} />}>
                                        <Route path="statement" element={<PrivateRoute element={<StatementTab />} />} />
                                        <Route path="information" element={<PrivateRoute element={<InformationTab />} />} />
                                        <Route path="payslip" element={<PrivateRoute element={<PayslipTab />} />} />
                                        <Route path="timesheet" element={<PrivateRoute element={<TimesheetTab />} />} />
                                        {/* <Route path="skills" element={<PrivateRoute element={<SkillsPage />} />} /> */}
                                        <Route path="expense" element={<PrivateRoute element={<ExpenseTab />} />} />
                                        <Route path="companyBenefit" element={<PrivateRoute element={<CompanyBenefitsTab />} />} />
                                        <Route path="overflow" element={<PrivateRoute element={<OverflowAccountTab isAdmin  />} />} />

                                    </Route>
                                </Route>
                                {/* <Route path="/overflowManagement" element={<PrivateRoute element={<OverflowOptimization />} />} /> */}
                                <Route path="/overflowManagement" element={<PrivateRoute element={<OverflowHome />} />} >
                                    {/* <Route index element={<PrivateRoute element={<OverflowAccountManager />} />} /> */}
                                    {/* <Route index element={<PrivateRoute element={<OverflowOptimization />} />} /> */}
                                    {/* <Route path=":investmentVehicleId" element={<PrivateRoute element={<InvestmentDetails />} />} /> */}
                                    {/* <Route path="create" element={<PrivateRoute element={<InvestmentDetails isCreating />} />} /> */}
                                </Route>
                                <Route path="/prospects" element={<PrivateRoute element={<Prospects />} />}>
                                    <Route index element={<PrivateRoute element={<ProspectsHome />} />} />
                                    <Route path="cv/:prospectID" element={<PrivateRoute element={<CVProspect />} />}>
                                        <Route index element={<PrivateRoute element={<CVTab isForProspect />} />} />
                                        <Route path="generate" element={<PrivateRoute element={<GenerateCV isForProspect />} />} />
                                        <Route path="generate/:templateID" element={<PrivateRoute element={<GenerateCV isForProspect />} />} />
                                    </Route>
                                </Route>
                                <Route path="/management" element={<PrivateRoute element={<Management />} />}>
                                    <Route index element={<Navigate to="onboarding" replace />} />
                                    {/* Routes de gestion des conditions du site (mentions legales) : decommissionnees cote UI,
                                        fermees via availableRoutes.js. Conservees pour pouvoir etre reactivees. */}
                                    <Route path="website" element={<PrivateRoute element={<ManagementWebsite />} />} />
                                    <Route path="website/:type" element={<PrivateRoute element={<ManagementWebsite />} />} />
                                    <Route path="onboarding" element={<PrivateRoute element={<ManagementOnboarding />} />} />
                                    <Route path="onboarding/:candidateUuid" element={<PrivateRoute element={<ManagementOnboardingCandidateDetails />} />} />
                                </Route>

                                {/* For consultant vision */}
                                <Route path="/administration" element={<PrivateRoute element={<Administration />} />}>
                                    <Route path="statement" element={<PrivateRoute element={<StatementTabUser />} />} />
                                    <Route path="information" element={<PrivateRoute element={<InformationTabUser />} />} />
                                    <Route path="payslip" element={<PrivateRoute element={<PayslipTabUser />} />} />
                                    <Route path="expense" element={<PrivateRoute element={<ExpenseTabUser />} />} />
                                    <Route path="companyBenefit" element={<PrivateRoute element={<CompanyBenefitsTabUser />} />} />
                                    <Route path="timesheet" element={<PrivateRoute element={<TimesheetTabUser />} />} />
                                </Route>
                                <Route path="/overflowSimulation" element={<PrivateRoute element={<OverflowSimulator fakeData />} />} />

                                <Route path="/overflow" element={<PrivateRoute element={<OverflowHome />} />} >
                                    <Route index element={<PrivateRoute element={<OverflowAccountTab />} />} />

                                    {/* <Route index element={<PrivateRoute element={<OverflowOptimizationUser />} />} /> */}
                                    {/* <Route path="simulate" element={<PrivateRoute element={<OverflowSimulator />} />} /> */}
                                    {/* <Route path=":investmentVehicleId" element={<PrivateRoute element={<InvestmentDetailsUser />} />} /> */}

                                </Route>

                                {/* Errors pages */}
                                <Route path="*" element={<ErrorPage/>}/>
                                </Routes>
                            </AppDataProvider>
                        </NotificationProvider>
                    </AuthProvider>
                </FeaturesProvider>
            </TrailingSlashRedirect>
        </Router>
    );
};

export default App;
